import VueI18n from 'vue-i18n'
import Vue from 'vue'
import yy from 'yach-jsapi';
const enUs = require("./en-US.json");
const zhCn = require("./zh-CN.json");

Vue.use(VueI18n) // 通过插件的形式挂载

const i18n = new VueI18n({
  locale: yy.env.language,    // 语言标识
  messages: {
    'en-US': enUs,
    'zh-CN': zhCn
  }
})
export default i18n;

export const isEn = yy.env.language === 'en-US';
export const isCn = yy.env.language === 'zh-CN';

export const locale = (text) => {
  const languageJson = isEn ? enUs : zhCn;
  return languageJson[text];
}

